
import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'

export const FORGOT_PAGE_LOAD = 'FORGOT_PAGE_LOAD'
export const FORGOT_ENTER_EMAIL = 'FORGOT_ENTER_EMAIL'
export const FORGOT_PASSWORD_REQUESTING = 'FORGOT_PASSWORD_REQUESTING'
export const FORGOT_PASSWORD_REQUEST_ERROR = 'FORGOT_PASSWORD_REQUEST_ERROR'
export const FORGOT_PASSWORD_REQUESTED = 'FORGOT_PASSWORD_REQUESTED'

export const forgotEnterEmail = createAction(FORGOT_ENTER_EMAIL)
export const forgotPasswordRequesting = createAction(FORGOT_PASSWORD_REQUESTING)
export const forgotPasswordRequestError = createAction(FORGOT_PASSWORD_REQUEST_ERROR)
export const forgotPasswordRequested = createAction(FORGOT_PASSWORD_REQUESTED)

export const forgotPageLoad = () => dispatch => {
  dispatch({ type: FORGOT_PAGE_LOAD })
  window.analytics.page('Password', 'Forgot')
}

export const forgotPassword = email => dispatch => {
  dispatch(forgotPasswordRequesting())

  fetch('/api/password-resets', {
    method: 'POST',
    body: JSON.stringify({ email })
  }).then(res => {
    if (!res.ok) {
      dispatch(forgotPasswordRequestError({ error: res.body.error, status: res.status }))
    } else {
      window.analytics.track('Forgot Password Email Sent', { email })
      dispatch(forgotPasswordRequested())
    }
  }).catch(err => {
    dispatch(forgotPasswordRequestError({ error: err }))
  })
}



// WEBPACK FOOTER //
// ./actions/forgot.js